<template>
  <img
    v-if="providerImage"
    :src="`/images/${providerImage}`"
    class="w-4 h-4 shrink-0"
    data-cy="provider-icon"
    loading="lazy"
    :alt
  />
</template>
<script setup lang="ts">
import { computed } from "vue";

import { EmailProvider } from "@/enums/communicationLogs";
import { CommunicationProvider } from "@/enums/communicationProviders";

import type { LogProvider } from "@/models/communication";

const { provider, alt } = defineProps<{
  provider?: LogProvider;
  alt?: string;
}>();

const providerImage = computed(() => {
  if (!provider) {
    return null;
  }
  const providerMap: Record<LogProvider, string> = {
    [CommunicationProvider.RingCentral]: "ringcentral_small.svg",
    [CommunicationProvider.Twilio]: "twilio.svg",
    [EmailProvider.Gmail]: "google.svg",
    [EmailProvider.AWS]: "",
  };

  return providerMap[provider] ?? null;
});
</script>
